export class ResetPasswordRequest {
  email: string;
  token: string;
  password: string;
}
